import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch"

const deleteAbsenceType = (
    backend: string,
    token: string,
    id: number
) => {
    
    return fetch(
        
        `${getApiUrl(backend)}absence/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deleteAbsenceType